import { render, staticRenderFns } from "./AdminPolicyDelete.vue?vue&type=template&id=d646a796&scoped=true"
import script from "./AdminPolicyDelete.vue?vue&type=script&lang=js"
export * from "./AdminPolicyDelete.vue?vue&type=script&lang=js"
import style0 from "./AdminPolicyDelete.vue?vue&type=style&index=0&id=d646a796&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d646a796",
  null
  
)

export default component.exports